module.exports = __webpack_public_path__ + "img/IDInVivo+_logo.2c1c8fcf.png";